"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentKey = void 0;
var EnvironmentKey = {
  Production: "production",
  Staging: "staging"
};
exports.EnvironmentKey = EnvironmentKey;